import React from 'react';
import Link from 'next/link';
import PhoneInput from 'react-phone-input-2';
import { ArrowBackIcon, Card, DniInput, Input } from '@avila-tek/ui/src';
import { dniTypes } from '../../../../static';
import { ACTIONS, ACTIONS_TYPE } from './reducer';
import { Company, UserTypeEnum } from '../../../../models';
import FormHeader, { FormHeaderProps } from '../FormHeader';

interface CompanyDataFormProps {
  dispatch: React.Dispatch<ACTIONS_TYPE>;
  state: Partial<Company>;
  header: FormHeaderProps;
  userType: UserTypeEnum;
  readOnly?: boolean;
}

function CompanyDataForm({
  state,
  dispatch,
  header,
  userType,
  readOnly = false,
}: CompanyDataFormProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch({ type: name as any, payload: value });
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    dispatch({ type: name as any, payload: value });
  };

  return (
    <Card>
      <FormHeader
        href={header.href}
        backBtnText={header?.backBtnText}
        title={header?.title ?? ''}
      />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full">
            <Input
              name={ACTIONS.NAME}
              value={state?.name ?? ''}
              label="Nombre"
              type="text"
              placeholder="Ingrese un nombre"
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </div>
          <div className="w-full">
            <Input
              name={ACTIONS.EMAIL}
              value={state?.email ?? ''}
              label="Correo electrónico"
              type="email"
              placeholder="Ingrese un correo electrónico"
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </div>
        </div>
        <div className=" flex md:flex-row flex-col gap-5">
          <div className="w-full">
            <DniInput
              label="RIF"
              defaultSelect={dniTypes[0].value}
              selectName={ACTIONS.DNI_TYPE}
              inputName={ACTIONS.DNI}
              selectValue={state?.dniType}
              inputValue={state?.dni ?? ''}
              handleChangeSelect={handleChangeSelect}
              handleChange={handleChange}
              disabled={readOnly}
              placeholder="Ingrese el RIF"
            >
              <option value="J">J-</option>
            </DniInput>
          </div>
          <div className="w-full">
            <span className="text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider  ">
              Teléfono
            </span>
            <PhoneInput
              inputStyle={{
                appearance: 'none',
                height: '32px',
                background: 'transparent',
                width: '100%',
                border: 'solid',
                borderWidth: '0.5px',
                borderColor: '#A6A6A6',
                borderRadius: '4px',
                minHeight: '40px',
                fontSize: '16px',
                color: '#606060',
                fontWeight: '300',
              }}
              countryCodeEditable={false}
              country="ve"
              value={state?.phone}
              placeholder="Ingrese un teléfono"
              onChange={(phone) => {
                dispatch({ type: ACTIONS.PHONE, payload: phone });
              }}
              disabled={readOnly}
              defaultMask="... ... ...."
            />
          </div>
        </div>
        <div className=" flex md:flex-row flex-col gap-5" />
      </Card.Body>
    </Card>
  );
}

export default CompanyDataForm;
